export default __webpack_public_path__ + "navigation-examples-location-snapping-1200-dc62b877bd288e1324b5c08c9e913e0a.webp";